import { getRefLanguageLevels } from "../../../components/services/httpService";

export async function fetchRefLanguageLevels() {
    const res = await getRefLanguageLevels();
    if ( !res.ok ) {
        throw new Error( `Failed: ${res.status}` );
    }
    return await res.json();
}
